import { camelCase } from 'lodash';
import getFieldMeta from './getFieldMeta';

const generateFieldKey = ({ fields, prefix = '', isCopy = false }) => {
  let key;
  do {
    const rand = Math.trunc(Math.random() * 1000);

    if (isCopy) {
      // Remove last -number if present
      const basePrefix = prefix.replace(/-\d+$/, '');
      key = `${basePrefix}-${rand}`;
    } else {
      key = camelCase(`${prefix}${rand}`);
    }
  } while (getFieldMeta({ fields, key: 'key', value: key }));

  return key;
};

export default generateFieldKey;
